import React from "react";
import { Row, Space, Typography } from "antd";
import { MailOutlined, PhoneOutlined, GlobalOutlined } from "@ant-design/icons";
const { Text } = Typography;

const ContactDisplay = ({ phone, email, website }) => {
  // console.log({ phone, email, website });
  return !phone && !email && !website ? (
    <Text style={{ marginBottom: "1rem" }}>No contact available</Text>
  ) : (
    <Space.Compact direction="vertical">
      {phone ? (
        <Row style={{ margin: "0.5rem 0", fontSize: "1rem" }}>
          <PhoneOutlined style={{ marginRight: "1rem" }} />
          {phone}
        </Row>
      ) : null}

      {email ? (
        <Row style={{ margin: "0.5rem 0", fontSize: "1rem" }}>
          <MailOutlined style={{ marginRight: "1rem" }} />
          {email}
        </Row>
      ) : null}

      {website ? (
        <Row style={{ margin: "0.5rem 0", fontSize: "1rem" }}>
          <GlobalOutlined style={{ marginRight: "1rem" }} />
          https://{website}
        </Row>
      ) : null}
    </Space.Compact>
  );
};

export default ContactDisplay;
